(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["da-conversion-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const form = document.querySelector('form.product-single__form');
    const originalButton = form?.querySelector('button[name="add"]');
    const campaignBadge = document.querySelector('[data-da-campaign-badge]');
    const rating = document.querySelector('[data-da-store-rating]');
    const selected = document.querySelector('[data-da-selected]');
    const sizeGuide = document.querySelector('[data-da-size-guide]');
    const assurance = document.querySelector('[data-da-product-assurance]');
    const sticky = document.querySelector('[data-da-sticky]');
    const stickySelection = sticky?.querySelector('[data-da-sticky-selection]');
    const stickyButton = sticky?.querySelector('[data-da-sticky-submit]');

    if (form && originalButton) {
      const titles = [...document.querySelectorAll('.product-single__title, main h1')];
      const title = titles.find((item) => item.offsetParent !== null) || titles[0];
      if (rating && title) title.insertAdjacentElement('afterend', rating);
      if (campaignBadge && rating) rating.insertAdjacentElement('afterend', campaignBadge);
      const sizeFieldset = document.querySelector('fieldset[data-handle="size"]');
      if (sizeGuide && sizeFieldset) sizeFieldset.insertAdjacentElement('afterend', sizeGuide);
      if (selected) form.insertAdjacentElement('beforebegin', selected);
      if (assurance) form.insertAdjacentElement('afterend', assurance);

      const selectedValue = (name) => document.querySelector('input[name="' + name + '"]:checked')?.value || '';
      const updateSelection = () => {
        const values = [selectedValue('Size'), selectedValue('Canvas Type')].filter(Boolean);
        const priceElement = document.querySelector('[data-product-price]');
        const accessiblePrice = priceElement?.querySelector('.visually-hidden')?.textContent.trim() || '';
        let price = accessiblePrice;
        if (!price && priceElement) {
          const cents = priceElement.querySelector('sup');
          if (cents) {
            const whole = [...priceElement.childNodes]
              .find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim())
              ?.textContent.trim() || '';
            price = whole + '.' + cents.textContent.trim();
          } else {
            price = priceElement.textContent.replace(/\s+/g, ' ').trim();
          }
        }
        const summary = [...values, price].filter(Boolean).join(' · ');
        const selectedText = selected?.querySelector('[data-da-selected-text]');
        if (selectedText) selectedText.textContent = summary;
        if (stickySelection) stickySelection.textContent = summary;
        if (stickyButton) stickyButton.disabled = originalButton.disabled;
      };

      document.addEventListener('change', (event) => {
        if (event.target.matches('[data-variant-input]')) {
          updateSelection();
          window.setTimeout(updateSelection, 120);
        }
      });

      stickyButton?.addEventListener('click', () => originalButton.click());
      const updateSticky = () => {
        if (!sticky) return;
        const rect = originalButton.getBoundingClientRect();
        const show = rect.bottom < 0;
        sticky.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('da-sticky-visible', show);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      new MutationObserver(updateSelection).observe(originalButton, { attributes: true });
      updateSelection();
      updateSticky();
    }

    const cartTemplate = document.querySelector('[data-da-cart-template]');
    const addCartReassurance = () => {
      if (!cartTemplate) return;
      const targets = document.querySelectorAll('.cart__checkout-wrapper, .cart__drawer-form [name="checkout"]');
      targets.forEach((target) => {
        const parent = target.closest('.cart__checkout-wrapper') || target.parentElement;
        if (!parent || parent.parentElement?.querySelector(':scope > [data-da-cart-reassurance]')) return;
        const reassurance = cartTemplate.content.firstElementChild.cloneNode(true);
        parent.insertAdjacentElement('beforebegin', reassurance);
      });
    };

    addCartReassurance();
    new MutationObserver(addCartReassurance).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
